var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotStartedStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "0imju61zla",
    x1: "0%",
    x2: "100%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5D6870"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#90A0AB"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#0imju61zla)",
    fillRule: "nonzero",
    transform: "translate(-1041 -305)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 1.28C4.294 1.28 1.28 4.295 1.28 8c0 3.705 3.015 6.72 6.72 6.72 3.705 0 6.72-3.015 6.72-6.72 0-3.705-3.015-6.72-6.72-6.72zM6.513 4.093c.442 0 .8.359.8.8v6.08c0 .442-.358.8-.8.8-.442 0-.8-.358-.8-.8v-6.08c0-.442.358-.8.8-.8zm3.2 0c.442 0 .8.359.8.8v6.08c0 .442-.358.8-.8.8-.442 0-.8-.358-.8-.8v-6.08c0-.441.358-.8.8-.8z",
    transform: "translate(99 106) translate(352 167) translate(580 25) translate(10 7)"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotStartedStatus);
export default __webpack_public_path__ + "static/media/not-started-status.f644d286304bacffba433cc01f4a5f27.svg";
export { ForwardRef as ReactComponent };